<template>
  <div>
    <div class="title" @click="goBack">
      <van-icon name="arrow-left" />
      <h2>我的申请</h2>
    </div>
    <div class="content">
      <table class="application-table">
        <thead>
          <tr>
            <th>序号</th>
            <th width="150">申请系统</th>
            <th width="100">申请时间</th>
            <th width="100">试用期限</th>
            <th width="100">当前状态</th>
            <th width="100">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in applications" :key="index">
            <td class="item">{{ index + 1 }}</td>
            <td>{{ item.systemName }}</td>
            <td class="item">{{ formatDate(item.createTime) }}</td>
            <td class="item">15天</td>
            <td class="item">
              <span v-if="item.status == '1'">通过</span>
              <span v-if="item.status == '0'">驳回</span>
              <span v-if="item.status == '2'">审核中</span>
            </td>
            <td class="item">
              <van-button @click="handleAction(item)" size="small" type="danger">撤销</van-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getApplyList, cancelApply } from '@/api/index'
import { Toast } from 'vant';
export default {
  name: "tryOut",
  data() {
    return {
      applications: [
      ],
    };
  },
  mounted() {
    this.getExchangeRecord();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleAction(item) {
      // 撤销申请的逻辑
      console.log(item);
      cancelApply(item.id).then(res => {
        Toast('撤销成功');
        this.getExchangeRecord()
      });
      // 这里可以添加 API 调用来撤销申请
    },
    //获取申请列表
    async getExchangeRecord() {
      let data = {
        page: 1,
        size: 999
      }
      const res = await getApplyList(data);
      this.applications = res.content;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.title {
  padding: 20px 20px 10px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px 20px 70px;
}

.application-table {
  width: 100%;
  border-collapse: collapse;
}

.application-table th,
.application-table td {
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
}

.item {
  vertical-align: middle;
}

.application-table th {
  background-color: #f9f9f9;
}
</style>
